export function isRunningFiniteAnimation(animation: Animation): boolean {
  const iterations = animation.effect?.getComputedTiming().iterations
  return animation.playState === "running" && iterations !== undefined && Number.isFinite(iterations)
}

export function runningFiniteAnimations(scope: Document | Element): Animation[] {
  const animations = scope instanceof Document ? scope.getAnimations() : scope.getAnimations({ subtree: true })
  return animations.filter(isRunningFiniteAnimation)
}

export async function finishOfRunningAnimations(scope: Document | Element): Promise<void> {
  await Promise.allSettled(runningFiniteAnimations(scope).map((animation) => animation.finished))
}
